import { Component,OnInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { navItems } from '../../_nav';
import { AuthenticationService } from '../../views/services/authentication/authentication.service';
import { Router } from '@angular/router';
import { IUser } from '../../views/models/user';
import { timer, Subscription } from 'rxjs';
import { FetchScheduledCallsDemosService } from './fetch-scheduled-calls-demos.service';
import { ICallsDemos } from './i-scheduledCallsDemos';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnDestroy, OnInit {
  public sb_navitems = null;
  public sidebarMinimized = true;
  public element: HTMLElement;
  public userName: string;

  private changes: MutationObserver;
  private currentUser: IUser;

  private fetchSchedulesTimer;
  private fetchSchedulesSub: Subscription;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private _fetchScheduledCallsDemosService: FetchScheduledCallsDemosService,
    @Inject(DOCUMENT) _document?: any
  ) {

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = _document.body.classList.contains('sidebar-minimized');
    });
    this.element = _document.body;
    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  ngOnInit(){
    this.currentUser = this.authenticationService.currentUserValue;
    this.userName = this.currentUser.partnerinfo[0].uname.charAt(0);
    
    // Get the role string (adjust 'NewRole' to match whatever cname they actually have)
    const userRole = this.currentUser.partnerinfo[0].cname;

    // ==========================================
    // 1. ISOLATED MENU FOR THE NEW ROLE
    // ==========================================
    if (userRole === 'BKChapChap') {
      
      // Define exactly what this user should see. 
      // They will NOT see any of the standard navItems.
      this.sb_navitems = [
        {
          name: 'Dashboard',
          url: '/dashboard',
          icon: 'icon-speedometer'
        },
        {
          name: 'New Users',
          url: '/base/chapchap/newUsers',
          icon: 'icon-people',
          visible: true
        },
        {
          name: 'Company Details',
          url: '/base/chapchap/companyDetails',
          icon: 'icon-briefcase',
          visible: true
        },
        {
          name: 'Transactions',
          url: '/base/chapchap/transactions',
          icon: 'icon-credit-card',
          visible: true
        },
        // Add more specific menus for this role here if needed:
        // { name: 'Special Reports', url: '/reports', icon: 'icon-chart' }
      ];

    } 
    // ==========================================
    // 2. EXISTING LOGIC FOR ADMIN, SALES, MANAGER
    // ==========================================
    else if ((userRole == 'admin') || (userRole == 'sales') || (userRole == 'manager'))
    {
      //navItems[navItems.findIndex( item => item.name == 'Assign Leads' )].visible = true;
      //navItems[navItems.findIndex( item => item.name == 'Assign Boxes' )].visible = true;
      navItems[navItems.findIndex( item => item.name == 'Insert Adminer Leads' )].visible = true;
      navItems[navItems.findIndex( item => item.name == 'Activations' )].visible = true;
      navItems[navItems.findIndex( item => item.name == 'Partners' )].visible = true;
      navItems[navItems.findIndex( item => item.name == 'Upgrade Retail Box' )].visible = true;      
      navItems[navItems.findIndex( item => item.name == 'Change Partner' )].visible = true;
      navItems[navItems.findIndex( item => item.name == 'Distributor Activations' )].visible = true;
      navItems[navItems.findIndex( item => item.name == 'Check Plan Price' )].visible = true;
      navItems[navItems.findIndex( item => item.name == 'Request License' )].visible = true;

      if (userRole === 'admin')
      {
        navItems[navItems.findIndex( item => item.name === 'Leads with Phone No./Email Id' )].visible = true;
      }
      else
      {
        navItems[navItems.findIndex( item => item.name === 'Leads with Phone No./Email Id' )].visible = false;
      }
      
      this.sb_navitems = navItems.filter( items => items.visible == true );
    }
    // ==========================================
    // 3. EXISTING LOGIC FOR ALL OTHER USERS
    // ==========================================
    else
    {
      //navItems[navItems.findIndex( item => item.name == 'Assign Leads' )].visible = false;
      //navItems[navItems.findIndex( item => item.name == 'Assign Boxes' )].visible = false;
      navItems[navItems.findIndex( item => item.name == 'Insert Adminer Leads' )].visible = false;
      navItems[navItems.findIndex( item => item.name == 'Activations' )].visible = true;
      navItems[navItems.findIndex( item => item.name == 'Partners' )].visible = false;
      navItems[navItems.findIndex( item => item.name == 'Upgrade Retail Box' )].visible = false;
      navItems[navItems.findIndex( item => item.name == 'Change Partner' )].visible = false;
      navItems[navItems.findIndex( item => item.name == 'Distributor Activations' )].visible = false;
      navItems[navItems.findIndex( item => item.name == 'Check Plan Price' )].visible = true;
      navItems[navItems.findIndex( item => item.name == 'Request License' )].visible = true;
      
      if (userRole === 'marketing')
      {
        navItems[navItems.findIndex( item => item.name === 'Leads with Phone No./Email Id' )].visible = true;
      }
      else
      {
        navItems[navItems.findIndex( item => item.name === 'Leads with Phone No./Email Id' )].visible = false;
      }

      this.sb_navitems = navItems.filter( items => items.visible == true );
    }

    
    if (Notification.permission == 'default')
    {
      Notification.requestPermission();
    }
    this.fetchSchedulesTimer = timer(2000, 600000);
    this.fetchSchedulesSub = this.fetchSchedulesTimer.subscribe( t => this.fetchSchedules() );
  }

  fetchSchedules() {
    this._fetchScheduledCallsDemosService.getScheduledCallsDemos().subscribe(
      result => {
        if ((Notification.permission == 'granted') && (result.data.length > 0))
        {
          this.notifyUser(result.data);
        }
      }
    );
  }

  notifyUser(schedules: ICallsDemos[]) {
    for (let i = 0; i <= schedules.length - 1; i++)
    {
      let callDemoNotification = new Notification(schedules[i].status, {
        requireInteraction: true,
        icon: '../../../assets/img/avatars/notification-icon.png',
        body: schedules[i].u_name + ' at ' + schedules[i].calldemo_time + (schedules[i].phone ? '\nPhone: ' + schedules[i].phone : '') + (schedules[i].email ? '\nEmail: ' + schedules[i].email : '')
      });
    }
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
    this.fetchSchedulesSub.unsubscribe();
  }

  logout(){
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  redirectToProfile(){
    this.router.navigate(['/base/profile']);
  }

  redirectToResetPassword() {
    this.router.navigate(['/base/resetpassword']);
  }
}